import HWY_Accordion from "./accordion";
import HWY_Slider from "./slider";
import HWY_Media from "./media";
import HWY_ValueStack from "./value-stack";
import HWY_CountDown from "./countdown";
import HWY_Menus from "./menus";
import HWY_Shop from "./shop";
import HWY_Blog from "./blog";
import HWY_Events from "./events";
import HWY_Product from "./product";

export default function Modules() {
	this.init = () => {
		new HWY_Accordion().init();
		new HWY_Slider().init();
		new HWY_Media().init();
		new HWY_ValueStack().init();
		new HWY_CountDown().init();
		new HWY_Menus().init();
		new HWY_Shop().init();
		new HWY_Blog().init();
		new HWY_Events().init();
		new HWY_Product().init();
	};
}